import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const getAuthHeaders = () => {
  const token = localStorage.getItem('adminToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Inquiries API
export const inquiriesAPI = {
  getAll: async (params = {}) => {
    const response = await axios.get(`${API_URL}/api/admin/inquiries`, {
      headers: getAuthHeaders(),
      params
    });
    return response.data;
  },
  
  getById: async (id) => {
    const response = await axios.get(`${API_URL}/api/admin/inquiries/${id}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  },
  
  update: async (id, data) => {
    const response = await axios.put(`${API_URL}/api/admin/inquiries/${id}`, data, {
      headers: getAuthHeaders()
    });
    return response.data;
  },
  
  delete: async (id) => {
    const response = await axios.delete(`${API_URL}/api/admin/inquiries/${id}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  }
};

// Services API
export const servicesAPI = {
  getAll: async (params = {}) => {
    const response = await axios.get(`${API_URL}/api/admin/services`, {
      headers: getAuthHeaders(),
      params
    });
    return response.data;
  },
  
  create: async (data) => {
    const response = await axios.post(`${API_URL}/api/admin/services`, data, {
      headers: getAuthHeaders()
    });
    return response.data;
  },
  
  update: async (id, data) => {
    const response = await axios.put(`${API_URL}/api/admin/services/${id}`, data, {
      headers: getAuthHeaders()
    });
    return response.data;
  },
  
  delete: async (id) => {
    const response = await axios.delete(`${API_URL}/api/admin/services/${id}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  }
};

// Pages API
export const pagesAPI = {
  getAll: async () => {
    const response = await axios.get(`${API_URL}/api/admin/pages`, {
      headers: getAuthHeaders()
    });
    return response.data;
  },
  
  getByKey: async (pageKey) => {
    const response = await axios.get(`${API_URL}/api/admin/pages/${pageKey}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  },
  
  create: async (data) => {
    const response = await axios.post(`${API_URL}/api/admin/pages`, data, {
      headers: getAuthHeaders()
    });
    return response.data;
  },
  
  update: async (pageKey, data) => {
    const response = await axios.put(`${API_URL}/api/admin/pages/${pageKey}`, data, {
      headers: getAuthHeaders()
    });
    return response.data;
  }
};

// Blocked IPs API
export const blockedIPsAPI = {
  getAll: async () => {
    const response = await axios.get(`${API_URL}/api/admin/blocked-ips`, {
      headers: getAuthHeaders()
    });
    return response.data;
  },
  
  create: async (data) => {
    const response = await axios.post(`${API_URL}/api/admin/blocked-ips`, data, {
      headers: getAuthHeaders()
    });
    return response.data;
  },
  
  delete: async (id) => {
    const response = await axios.delete(`${API_URL}/api/admin/blocked-ips/${id}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  }
};

// Analytics API
export const analyticsAPI = {
  getDashboard: async (days = 30) => {
    const response = await axios.get(`${API_URL}/api/admin/analytics`, {
      headers: getAuthHeaders(),
      params: { days }
    });
    return response.data;
  },
  
  getStats: async () => {
    const response = await axios.get(`${API_URL}/api/admin/stats`, {
      headers: getAuthHeaders()
    });
    return response.data;
  }
};

// Users API
export const usersAPI = {
  getAll: async () => {
    const response = await axios.get(`${API_URL}/api/admin/users`, {
      headers: getAuthHeaders()
    });
    return response.data;
  },
  
  create: async (data) => {
    const response = await axios.post(`${API_URL}/api/admin/users`, data, {
      headers: getAuthHeaders()
    });
    return response.data;
  },

  update: async (id, data) => {
    const response = await axios.put(`${API_URL}/api/admin/users/${id}`, data, {
      headers: getAuthHeaders()
    });
    return response.data;
  },

  delete: async (id) => {
    const response = await axios.delete(`${API_URL}/api/admin/users/${id}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  },

  changeMyPassword: async (currentPassword, newPassword) => {
    const response = await axios.put(
      `${API_URL}/api/admin/profile/password`,
      { current_password: currentPassword, new_password: newPassword },
      { headers: getAuthHeaders() }
    );
    return response.data;
  }
};
